/*
 * This file is used to inject the configuration overrides into the generated bundle
 */
import { BundleDefaults } from './typings';

declare const CTA_BUILD: boolean;
declare const WIDGET_CONFIGURATION: BundleDefaults;
import defaults from './bundle-defaults';
import { proxyObjectToDefaults } from './util/objects';

let _config = defaults;
if (CTA_BUILD) {
  // The string "WIDGET_CONFIGURATION" will be replaced with the
  // dealer specific configuration at build time
  // @ts-ignore this creates a type error (assigning any to defaults object).
  //            This could be fixed with a defined type for defaults
  _config = WIDGET_CONFIGURATION;
}

const config: BundleDefaults = proxyObjectToDefaults(_config, defaults);

export default config;
